document.addEventListener('DOMContentLoaded', function () {
  var root = document.querySelector('[data-fb-root]');
  if (!root) return;

  var qty = 1;
  var qtyEl = root.querySelector('[data-fb-qty]');
  root.querySelector('[data-fb-qty-minus]').addEventListener('click', function () {
    qty = Math.max(1, qty - 1);
    qtyEl.textContent = qty;
  });
  root.querySelector('[data-fb-qty-plus]').addEventListener('click', function () {
    qty += 1;
    qtyEl.textContent = qty;
  });

  root.querySelectorAll('[data-fb-item]').forEach(function (item) {
    var variantsScript = item.querySelector('[data-fb-variants]') || item.nextElementSibling;
    var variants = [];
    if (variantsScript) {
      try { variants = JSON.parse(variantsScript.textContent); } catch (e) {}
    }

    var optionEls = Array.prototype.slice.call(item.querySelectorAll('[data-fb-option]'));
    var selections = {};

    optionEls.forEach(function (optionEl) {
      var idx = optionEl.getAttribute('data-option-index');
      var firstBtn = optionEl.querySelector('[data-fb-value]');
      if (firstBtn) selections[idx] = firstBtn.getAttribute('data-value');
    });

    function findMatch(sel) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], match = true;
        for (var idx in sel) {
          if (v['option' + (parseInt(idx, 10) + 1)] !== sel[idx]) { match = false; break; }
        }
        if (match) return v;
      }
      return null;
    }

    function updateAvailability() {
      optionEls.forEach(function (optionEl) {
        var idx = optionEl.getAttribute('data-option-index');
        optionEl.querySelectorAll('[data-fb-value]').forEach(function (btn) {
          var testSel = {};
          for (var k in selections) testSel[k] = selections[k];
          testSel[idx] = btn.getAttribute('data-value');

          var match = findMatch(testSel);
          var isAvailable = match ? match.available : false;

          btn.classList.toggle('is-unavailable', !isAvailable);
          if (!isAvailable) {
            btn.setAttribute('aria-disabled', 'true');
          } else {
            btn.removeAttribute('aria-disabled');
          }
        });
      });
    }

    function updateItem() {
      var variant = findMatch(selections);
      if (!variant) return;

      var priceEl = item.querySelector('[data-fb-item-price]');
      if (priceEl) {
        priceEl.textContent = window.Shopify && Shopify.formatMoney
          ? Shopify.formatMoney(variant.price, window.theme && window.theme.moneyFormat)
          : (variant.price / 100).toFixed(2);
      }

      var imgWrap = item.querySelector('[data-fb-item-image] img');
      if (imgWrap && variant.featured_image) {
        imgWrap.src = variant.featured_image.src;
      }

      var propInput = item.querySelector('[data-fb-property]');
      if (propInput) propInput.value = variant.title;

      item.dataset.available = variant.available ? 'true' : 'false';
      updateAddToCartState();
    }

    optionEls.forEach(function (optionEl) {
      var idx = optionEl.getAttribute('data-option-index');
      optionEl.querySelectorAll('[data-fb-value]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (btn.classList.contains('is-unavailable')) return;
          optionEl.querySelectorAll('[data-fb-value]').forEach(function (b) { b.classList.remove('is-selected'); });
          btn.classList.add('is-selected');
          selections[idx] = btn.getAttribute('data-value');
          updateAvailability();
          updateItem();
        });
      });
    });

    updateAvailability();
    updateItem();
  });

  function updateAddToCartState() {
    var addBtn = root.querySelector('[data-fb-add-to-cart]');
    var allAvailable = true;
    root.querySelectorAll('[data-fb-item]').forEach(function (item) {
      if (item.dataset.available === 'false') allAvailable = false;
    });
    if (addBtn) {
      addBtn.disabled = !allAvailable;
      addBtn.textContent = allAvailable
        ? addBtn.dataset.defaultLabel || addBtn.textContent
        : 'أحد العناصر غير متوفر';
    }
  }

  root.querySelector('[data-fb-add-to-cart]').addEventListener('click', function () {
    var button = this;
    var errorEl = root.querySelector('[data-fb-error]');
    errorEl.hidden = true;

    var properties = {};
    root.querySelectorAll('[data-fb-property]').forEach(function (input) {
      properties[input.name] = input.value;
    });

    button.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{
          id: root.getAttribute('data-variant-id'),
          quantity: qty,
          properties: properties
        }]
      })
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (err) { throw new Error(err.description || 'Error'); });
        return res.json();
      })
      .then(function () {
        window.location.href = '/cart';
      })
      .catch(function (err) {
        errorEl.textContent = err.message;
        errorEl.hidden = false;
        button.disabled = false;
      });
  });
});